<template>
  <Modal
    v-model="visible"
    width="500px"
    class="appointment-order-form"
    title="新增预约投保单"
    :footer-hide="true"
    :mask-closable="false"
  >
    <Form
      ref="form"
      :model="formData"
      :label-width="130"
      class="page-form formGauge"
    >
      <FormItem
        prop="productId"
        label="投保产品"
        class="full"
        :rules="$units.formRule.required('请选择投保产品')"
      >
        <Select
          v-model="formData.productId"
          filterable
          @on-change="selectProduct"
        >
          <Option v-for="item in productList" :value="item.id" :key="item.id">{{
            item.productName
          }}</Option>
        </Select>
      </FormItem>
      <FormItem
        prop="insureArea"
        label="投保区域"
        class="full"
        :rules="$units.formRule.required('请选择投保区域','change',areaType==2?'array':'string')"
      >
        <Select v-model="formData.insureArea" filterable v-if="areaType==1">
          <Option v-for="(item, i) in areaColumns" :value="item" :key="i">{{
            item
          }}</Option>
        </Select>
        <Cascader v-if="areaType==2" :data="areaColumns" v-model="formData.insureArea" />
        <span class="info-text"
          >您可以选择户籍、工作或家庭住址所在的省份作为投保区域</span
        >
      </FormItem>
      <FormItem
        prop="holderName"
        label="投保人姓名"
        class="full"
        :rules="$units.formRule.required('请输入投保人姓名')"
      >
        <Input v-model="formData.holderName" placeholder="请输入" />
      </FormItem>
      <FormItem
        prop="holderIdCard"
        label="投保人身份证号"
        class="full"
        :rules="$units.formRule.idCard('请输入正确的投保人身份证号')"
      >
        <Input v-model="formData.holderIdCard" placeholder="请输入" />
      </FormItem>
      <FormItem
        prop="holderMobile"
        label="投保人手机号"
        class="full"
        :rules="$units.formRule.tel('请输入正确的投保人手机号')"
      >
        <Input v-model="formData.holderMobile" placeholder="请输入" />
      </FormItem>
    </Form>
    <div
      class="reminder"
      v-if="
        infoCode.includes(formData.productCode) && formData.insureArea == '河南'
      "
    >
      因监管需要，投保过程中需要上传人身投保提示书及投保人签字时的照片，请您提前下载
      <span @click="download">人身投保提示书</span>
      打印签字，同时在投保人签字时进行拍照
    </div>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="submit" :loading="loading">提交</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      visible: false,
      loading: false,
      formData: {
        insureArea: [],
      },
      userList: [], //业务员
      productList: [], //产品
      areaColumns: [], //投保区域
      areaType:1,
      infoCode: ["01022", "01024", "01025", "01026", "01027", "01028", "01030"], //需要显示提示的产品
      fileFalg:false,//判断文件是否下载
    };
  },
  computed: {},
  created() {},
  methods: {
    open() {
      this.$refs.form && this.$refs.form.resetFields();
      this.formData = {};
      this.areaType = 1;
      this.visible = true;
      this.getProductList();
    },
    // 选择产品
    selectProduct(id) {
      const bean = this.productList.find((item) => {
        return item.id == id;
      });
      if(!bean){
        this.areaColumns = [];
        this.formData.productCode = '';
        this.$set(this.formData, "insureArea", "");
        return;
      }
      this.areaType = 0;
      this.formData.productCode = bean.productCode;
      this.$set(this.formData, "insureArea", "");
      this.getAreaList();
    },
    // 获取产品列表
    getProductList() {
      this.$http({
        type: "GET",
        url: "/buz/productBase/getAppointProduct",
        data: {
          productName: "",
        },
      }).then((res) => {
        this.productList = res.data;
      });
    },
    //获取投保区域
    getAreaList() {
      this.$http({
        type: "GET",
        // url: "/buz/appointInsured/queryCustomInsureArea",
        url: "/buz/appointInsured/queryCustomInsureArea2",
        data: {
          productCode: this.formData.productCode,
        },
      }).then((resData) => {
        const data = resData.data
        this.areaType = data.type;
        if(data.type==1&&data.area){
          this.$set(this.formData, "insureArea", "");
          this.areaColumns = data.area.split(",");
        }else if(data.type==2&&data.area){
          this.$set(this.formData, "insureArea", []);
          this.formatData(data.area)
          this.areaColumns = data.area;
        }else{
          this.areaColumns = [];
        }
      });
    },
    formatData(data){
      if(data&&data.length){
        data.forEach(item=>{
          item.value = item.name;
          item.label = item.name;
          this.formatData(item.children);
        })
      }
    },
    submit() {
      // 判断是否需要验证文件下载
      if (
        this.infoCode.includes(this.formData.productCode) &&
        this.formData.insureArea == "河南"
      ) {
        if (!this.fileFalg) {
          this.$Message.warning('请下载投保提示书');
          return;
        }
      }
      this.$refs.form.validate().then((isok) => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        formData.source = "4";
        if(this.areaType==2){
          formData.insureArea = formData.insureArea.join('');
        }
        if (this.loading) {
          return;
        }
        this.loading = true;
        this.$http({
          type: "PUT",
          url: "/buz/appointInsured/edit",
          data: formData,
        })
          .then((res) => {
            this.$notice.success("提交成功");
            this.visible = false;
            this.$emit("suceess");
          })
          .finally((res) => {
            this.loading = false;
          });
      });
    },
    download() {
      this.fileFalg=true;
      this.$units.downloadFun({
        url: "https://file.fxyf99.com/product_material/20220421T0KD6a.pdf",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.appointment-order-form /deep/ {
  .info-text {
    color: #888;
    margin-top: 5px;
    font-size: 12px;
    line-height: 1.5;
  }
}
.reminder {
  width: 100%;
  height: 100px;
  font-size: 14px;
  // margin-top: 20px;
  color: #aa7745;
  padding: 12px 15px;
  background-color: #fff8f2;
  border-radius: 4px;
  span {
    color: #167aff;
    margin: 0 5px;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
